import { NgModule } from '@angular/core';
import { ErrorMessageComponent } from './error-message.component';
import { SafeModule } from '../../core/pipes/safe/safe.module';
import { InnerHtmlComponent } from '../add-inner-html/inner-html.component';

@NgModule({
  declarations: [ErrorMessageComponent],
  exports: [ErrorMessageComponent],
  imports: [SafeModule, InnerHtmlComponent],
})
export class ErrorMessageModule {}
